<app-loader></app-loader>
<app-toast-notification></app-toast-notification>
<router-outlet></router-outlet> 
